import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import changeLang from '../../redux/actions/lang';

class LangSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectLang: props.lang,
      langs: ['tr', 'en'],
      show: false,
    };
  }

  changeLang = (lang) => {
    const { dispatch } = this.props;

    localStorage.setItem('lang', lang);
    dispatch(changeLang(lang));
    this.setState({ selectLang: lang, show: false });
  }

  render() {
    const { langs, selectLang, show } = this.state;
    return (
      <SelectLangWrapper>
        <SelectedLang onClick={() => this.setState({ show: !show })}>
          <img src={`/images/flags/${selectLang}.png`} alt="" />
        </SelectedLang>
        <Langs show={show}>
          {
            langs.map((lang) => (
              <Lang key={lang} onClick={() => this.changeLang(lang)}>
                <img src={`/images/flags/${lang}.png`} alt="" />
              </Lang>
            ))
          }
        </Langs>
      </SelectLangWrapper>
    );
  }
}

LangSelect.propTypes = {
  dispatch: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};

const SelectLangWrapper = styled.div`
  position: relative;
`;
const Langs = styled.div`
  display: ${(props) => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 100%;
  z-index: 999;
  width: 100px;
  border: 1px solid transparent;
  background-color: gray;
  border-radius: 5px;
  padding-bottom: 10px;
`;
const SelectedLang = styled.div`
  background-color: transparent;
  border:none;
  padding: 0;
  cursor: pointer;
  img {
    width: 40px;
  }
  :focus {
    outline: none;
  }
`;
const Lang = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top:10px;
  cursor: pointer;
  img {
    width: 50px;
  }
`;

const mapStateToProps = (state) => ({ lang: state.lang.lang });

export default connect(mapStateToProps)(LangSelect);
